<template>
  <div>
    <mds-fieldset
      :legend="translate('scheduler.modal.delivery.attestation.title')"
      class="attestation-form__data-ditribution-fieldset"
      variation="checkbox-group"
    >
      <div class="attestation-form__data-ditribution-fieldset-checkbox">
        <input
          type="checkbox"
          id="checkbox"
          v-model="isAccepted"
          @change="handleAgreementCheck"
        />
        <label for="checkbox">
          <p class="attestation-form__data-ditribution-fieldset-text">
            {{ translate('scheduler.modal.delivery.attestation.text.confirm') }}
          </p>
          <p class="attestation-form__data-ditribution-fieldset-text">
            {{
              translate(
                'scheduler.modal.delivery.attestation.text.limited.confirm'
              )
            }}
          </p>
        </label>
      </div>
      <mds-button
        class="attestation-form__data-ditribution-fieldset-button"
        variation="secondary"
        type="button"
        size="small"
        target="_blank"
        :href="licenseUrl"
      >
        {{ translate('scheduler.modal.delivery.attestation.button') }}
      </mds-button>
    </mds-fieldset>
  </div>
</template>

<script>
import { MdsButton } from '@mds/button'
import MdsFieldset from '@mds/fieldset'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/schedulerModal/config/i18n'
export default {
  name: 'attestationForm',
  components: {
    MdsButton,
    MdsFieldset,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    editedFeed: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      defaultConfig,
      isAccepted: false,
    }
  },
  created() {
    if (this.editedFeed && this.editedFeed.attestation_form) {
      this.isAccepted = this.editedFeed.attestation_form === 'Yes'
    }
  },
  computed: {
    licenseUrl() {
      return process.env.DIRECT_LICENSE_URL
    },
  },
  methods: {
    handleAgreementCheck() {
      // Emit the event with the new checkbox state
      this.$emit('check-accept', this.isAccepted)
      if (this.editedFeed) {
        this.$emit('disable-save-button', false)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@mds/constants';

.attestation-form__data-ditribution-fieldset {
  margin-top: $mds-space-1-x;
  &-checkbox {
    display: flex;
    align-items: start;
    gap: $mds-space-1-x;
  }
  &-text {
    margin-left: $mds-space-half-x;

    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  &-button {
    margin-top: $mds-space-2-x;
    margin-left: $mds-space-4-x;
    padding-top: $mds-space-1-x;
    &::v-deep {
      > span {
        margin-bottom: 0px !important;
      }
    }
  }
}
</style>
